import { Reveal, SplitLines } from "./Reveal";

const CHAPTERS = [
  {
    n: "01", title: "Carat & sieve", sub: "Buy weight, not pieces.",
    body: "Melee is sold by total carat weight. A -2 sieve stone (0.50–1.20 mm) weighs roughly 0.005 ct, so a single carat is 150–250 pieces. Always ask for pieces-per-carat, not just the parcel weight — it tells you exactly how much setting work is ahead.",
    table: [["-2", "0.50–1.20 mm"], ["+2 to -4", "1.20–1.40 mm"], ["+4 to -6.5", "1.40–1.70 mm"], ["+6.5 to -11", "1.70–2.80 mm"], ["+11 to -15", "2.80–3.40 mm"], ["+15", "3.40 mm +"]],
  },
  {
    n: "02", title: "Cut & light", sub: "The only C humans control twice.",
    body: "Lab-grown rough is cut for beauty rather than yield, so 3EX (Excellent cut, polish, symmetry) is common and should be your baseline on any round above 0.30 ct. In fancy shapes, look for even brilliance, a small bow-tie and protected points.",
  },
  {
    n: "03", title: "Colour & growth", sub: "CVD Type IIa, D–F as standard.",
    body: "Modern CVD and HPHT growth yields consistently colourless goods. D–F is the norm for certified solitaires; G–H melee sets beautifully in yellow gold. Ask whether a stone is as-grown or post-growth treated — both are disclosed on our invoices.",
  },
  {
    n: "04", title: "Clarity FL → I3", sub: "Eye-clean is the target; VS2 is the value.",
    body: "FL and IF are collector grades. VVS is invisible even under a loupe to most buyers. VS1–VS2 is eye-clean in virtually every shape and is where value and beauty meet. SI1 is fine in brilliants; step cuts need VS or better. I1–I3 is commercial melee territory.",
    scale: ["FL", "IF", "VVS1", "VVS2", "VS1", "VS2", "SI1", "SI2", "I1", "I2", "I3"],
  },
];

export const WhatMatters = () => (
  <section id="what-matters" data-testid="what-matters-section" className="relative py-24 lg:py-36">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="mb-20 max-w-3xl">
        <Reveal><p className="eyebrow mb-6">03 — What Matters</p></Reveal>
        <h2 className="font-display font-light text-ivory text-[clamp(2.4rem,5.5vw,5rem)] leading-[0.95]">
          <SplitLines inView lines={["A manifesto", <span key="a" className="text-saffron italic">in four chapters.</span>]} />
        </h2>
      </div>

      <div className="space-y-px">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.05} className="group grid lg:grid-cols-12 gap-6 lg:gap-12 py-12 border-t border-gold/15 last:border-b" data-testid={`chapter-${c.n}`}>
            <div className="lg:col-span-2 font-display text-6xl lg:text-7xl text-gold/30 group-hover:text-saffron transition-colors duration-700 leading-none">{c.n}</div>
            <div className="lg:col-span-4">
              <h3 className="font-display text-3xl lg:text-4xl text-ivory leading-tight">{c.title}</h3>
              <p className="text-gold italic font-display text-xl mt-2">{c.sub}</p>
            </div>
            <div className="lg:col-span-6 space-y-6">
              <p className="text-ivory/70 font-light leading-relaxed">{c.body}</p>
              {c.table && (
                <table className="w-full text-sm border border-gold/15" data-testid="sieve-table">
                  <thead><tr className="text-[10px] uppercase tracking-[0.25em] text-gold bg-gold/5"><th className="text-left px-4 py-2 font-medium">Sieve / trade</th><th className="text-right px-4 py-2 font-medium">Approx. mm</th></tr></thead>
                  <tbody>{c.table.map(([a, b]) => <tr key={a} className="border-t border-gold/10 text-ivory/80"><td className="px-4 py-2 font-mono text-xs">{a}</td><td className="px-4 py-2 text-right">{b}</td></tr>)}</tbody>
                </table>
              )}
              {c.scale && (
                <div className="flex flex-wrap gap-1.5" data-testid="clarity-scale">
                  {c.scale.map((s, j) => (
                    <span key={s} className="px-3 py-1.5 text-xs tracking-[0.15em] border border-gold/20 text-ivory/80" style={{ background: `rgba(205,156,32,${0.22 - j * 0.02})` }}>{s}</span>
                  ))}
                </div>
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
